import { useParams } from "react-router-dom";
import { PoDetailsSetSnoozeContainer } from "./container";

export const PoDetailsSetSnoozePane = () => {
  const params = useParams();
  const { id } = params;
  return id ? <PoDetailsSetSnoozeContainer id={id} /> : <></>;
};
